module.exports = __webpack_public_path__ + "img/earth1.269a57a.webp";